const updateUser = (user) => ({
  type: 'UPDATE_USER',
  user,
});

export default updateUser;
